import * as React from "react";
import { makeStyles } from "@mui/styles";
import tokens from "../../../styles/designTokens";
import ReviewTab from "./review-tab";
import { Box, Tab, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import { buttonText2 } from "../../../styles/typography";
import GuideTab from "./guide-tab";
import { ReportBackgroundData } from "../../../redux/suggestions";
import { useSelector } from "react-redux";
import { selectReportBackgroundData } from "../../../selectors/suggestions";

const useStyles = makeStyles(() => ({
  resultsPage: {
    color: tokens.core3,
    '& .MuiTabPanel-root': {
      padding: 0
    }
  },
  tab: {
    width: '50%',
    ...buttonText2,
    '&.Mui-selected': {
      color: tokens.product100
    }
  },
}));

const ResultsPage = () => {
  const classes = useStyles();
  const reportBackgroundData: ReportBackgroundData = useSelector(selectReportBackgroundData);
  const [currentTab, setCurrentTab] = React.useState(0);

  const handleTabChange = (_: React.SyntheticEvent, nextTab: number) => {
    setCurrentTab(nextTab);
  };

  return (
    <div className={classes.resultsPage}>
      <TabContext value={currentTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={currentTab} onChange={handleTabChange} aria-label="Exact report tabs">
            <Tab className={classes.tab} label="Review" />
            <Tab className={classes.tab} label="Guide" />
          </Tabs>
        </Box>
        <TabPanel value={0}>
          {reportBackgroundData && <ReviewTab reportBackgroundData={reportBackgroundData}></ReviewTab>}
        </TabPanel>
        <TabPanel value={1} >
          { reportBackgroundData && <GuideTab countryCode={reportBackgroundData?.jurisdiction} />}
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default ResultsPage;